<template>
    <div class="spinner-border text-dark my-2" role="status">
        <span class="sr-only"></span>
    </div>
</template>

<script>
export default {
    name: "LoadingSpinner"
};
</script>


<style scoped lang="scss">
</style>
